import { Quill } from 'react-quill';
// components
// import Iconify from '../Iconify';
//
import EditorToolbarStyle from './EditorToolbarStyle';

// ----------------------------------------------------------------------

const FONT_FAMILY = ['Times'];

const FONT_SIZE = [
    '8px',
    '9px',
    '10px',
    '12px',
    '14px',
    '16px',
    '20px',
    '24px',
    '32px',
    '42px',
    '54px',
    '68px',
    '84px',
    '98px',
];
// const HEADINGS = ['Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5', 'Heading 6'];
// const HEADINGS = ['Heading 6'];

export function undoChange() {
    // @ts-ignore
    this.quill.history.undo();
}
export function redoChange() {
    // @ts-ignore
    this.quill.history.redo();
}

const Size = Quill.import('attributors/style/size');
Size.whitelist = FONT_SIZE;
Quill.register(Size, true);

const Font = Quill.import('attributors/style/font');
Font.whitelist = FONT_FAMILY;
Quill.register(Font, true);

export const formats = [
    'align',
    'background',
    'blockquote',
    'bold',
    'bullet',
    'code',
    'code-block',
    'color',
    'direction',
    'font',
    'formula',
    'header',
    'image',
    'indent',
    'italic',
    'link',
    'list',
    'script',
    'size',
    'strike',
    'table',
    'underline',
    'video',
];

type EditorToolbarProps = {
    id: string,
    isSimple?: boolean,
    maxWord?: number,
    word_count?: number,
};

export default function EditorToolbar({
    id,
    isSimple,
    maxWord,
    word_count,
    ...other
}: EditorToolbarProps) {
    return (
        <EditorToolbarStyle {...other}>
            <div id={id} style={{ display: 'flex', justifyContent: 'center' }}>
                {/* <div className="ql-formats">
        </div> */}

                <div className="ql-formats">
                    <button type="button" className="ql-align" value="" />
                    <button
                        type="button"
                        className="ql-align"
                        value="justify"
                    />
                    <button type="button" className="ql-align" value="center" />
                </div>

                <div className="ql-formats">
                    <button type="button" className="ql-bold" />
                    <button type="button" className="ql-italic" />
                    <button type="button" className="ql-underline" />
                    <button type="button" className="ql-strike" />
                </div>

                {/* <div className="ql-formats">
          <button type="button" className="ql-list" value="ordered" />
          <button type="button" className="ql-list" value="bullet" />
        </div> */}

                <div className="ql-formats">
                    <button type="button" className="ql-script" value="super" />
                    <button type="button" className="ql-script" value="sub" />
                </div>

                <div className="ql-formats">
                    <button type="button" className="ql-formula" />
                </div>

                <div className="ql-formats">
                    <span>
                        Words: {word_count} (max {maxWord})
                    </span>
                </div>
            </div>
        </EditorToolbarStyle>
    );
}
